/**
 * Controler for the modal
 */
imageMapEditZoneController.$inject = ['$scope', '$mdDialog', '$translate', 'QuickRepliesFactory', 'elementData', 'elementView', '$timeout'];
export function imageMapEditZoneController($scope, $mdDialog, $translate, QuickRepliesFactory, elementData, elementView, $timeout) {
  $scope.saveZone = saveZone;
  $scope.cancel = cancel;
  $scope.deleteItem = deleteItem;
  $scope.initTypeDropdownItems = initTypeDropdownItems;
  $scope.onTypeChange = onTypeChange;
  $scope.isFormValid = isFormValid;
  $scope.isUrlZoneValid = isUrlZoneValid;
  $scope.textRequired;
  $scope.urlRequired;
  let newBox = false;

  init();

  function init() {
    if (elementData.newBox) {
      newBox = true;
      delete elementData.newBox;
    }

    $scope.elementData = elementData;
    $scope.elementView = elementView;

    initTypeDropdownItems();
    onTypeChange();
  }

  function saveZone() {
    $mdDialog.hide({ type: 'ok', data: $scope.elementData });
  }

  /**
   * The zone must not exist without data (imagemap KO in line)
   * so if it's a new zone, the only options
   * are to delete it, or save it with valid data
   */
  function cancel() {
    if (newBox) {
      deleteItem();
    } else {
      $mdDialog.cancel();
    }
  }

  /**
   * Remove a Zone
   * Triggers a callback in editElement() in abstract-views.js
   */
  function deleteItem() {
    $mdDialog.hide({ type: 'delete' });
  }

  function initTypeDropdownItems() {
    $scope.typeDropdownItems = [
      {
        id: 'text',
        label: $translate.instant('parameters/quick_replies/details/graph/line_image_map/edit_zone_type_text')
      },
      {
        id: 'url',
        label: $translate.instant('parameters/quick_replies/details/graph/line_image_map/edit_zone_type_url')
      }
    ];
  }

  /**
   * When changing the type of the zone :
   * URL or simple text
   *
   * Timeout because we don't have the changed value when ngChange triggered.
   * "The expression (ngChange) is evaluated immediately,
   * unlike the JavaScript onchange event which only triggers at the end of a change"
   * https://docs.angularjs.org/api/ng/directive/ngChange
   */
  function onTypeChange() {
    $timeout(() => {
      if ($scope.elementData.type === 'url') {
        $scope.elementData.text = null;
        $scope.textRequired = false;
        $scope.urlRequired = true;
      } else {
        $scope.elementData.url = null;
        $scope.textRequired = true;
        $scope.urlRequired = false;
      }
    }, 0);
  }

  function isFormValid() {
    return $scope.modalForm.$valid && isUrlZoneValid();
  }

  function isUrlZoneValid() {
    if ($scope.elementData.type == 'url') {
      return QuickRepliesFactory.isLineUrlValid($scope.elementData.url);
    } else {
      return true;
    }
  }
}
